import type { VariantProps } from 'cva'
import { cva } from 'cva'
import Image from 'next/image'
import type { ComponentProps, FC } from 'react'
import type { ImageData, Maybe } from '../../frontend-types'
import { PlaceholderImage } from './PlaceholderImage'

const cardMasonryImageVariants = cva({
	base: 'relative overflow-hidden rounded-sm',
	variants: {
		layout: {
			square:
				'h-auto w-full tablet-p:h-full col-span-full aspect-4/3 tablet-p:col-span-4 tablet-p:min-h-84 tablet-l:col-span-6 tablet-l:min-h-87 desktop:col-span-4 desktop:min-h-82.5',
			wide: 'h-auto aspect-4/3 col-span-full desktop:aspect-auto desktop:h-full desktop:col-span-8',
		},
	},
	defaultVariants: {
		layout: 'square',
	},
})

const cardMasonryImageSizeVariants = cva({
	variants: {
		layout: {
			square:
				'(max-width: 767px) 100vw, (max-width: 1279px) 50vw, (max-width: 1559px) 33.33vw, 456px',
			wide: '(max-width: 767px) 100vw, (max-width: 1559px) 66.67vw, 936px',
		},
	},
})

export type CardMasonryImageType = VariantProps<typeof cardMasonryImageVariants> & {
	id: Maybe<string>
	image?: ImageData
	type: 'stat-blocks-masonry-image'
}

export type CardMasonryImageProps = ComponentProps<'div'> & {
	cardMasonryImage: CardMasonryImageType
}

export const CardMasonryImage: FC<CardMasonryImageProps> = ({ cardMasonryImage, ...props }) => {
	const { image, layout } = cardMasonryImage

	return (
		<div className={cardMasonryImageVariants({ layout })} {...props}>
			{image ? (
				<Image
					src={image.src}
					alt={image.alt}
					fill
					className="object-cover"
					sizes={cardMasonryImageSizeVariants({ layout })}
				/>
			) : (
				<PlaceholderImage />
			)}
		</div>
	)
}
